(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('flyerDetailDescription', {
            templateUrl: 'app/admin/flyers/flyer-detail/description-panel/flyer-detail-description.html',
            controller: flyerDetailDescriptionController,
            bindings: {
                flyer: '<',
                isImmoContext: '<',
                menuActions: '<',
                quickActions: '<',
                onSelectedChanged: '&',
                isHubContext: '<',
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function flyerDetailDescriptionController($rootScope, $localStorage, $scope, $sce, StoreService, ErpsSettingsService) {
        var vm = this;
        vm.configuration = {};

        const ERP_ICON_MAP = {
            11: {
                color: "#411D5A",
                iconClass: "erp-variation-icon icon-ksc-setadigital-solid",
                label: "global.erps.info.seta.integrated"
            },
            10: {
                color: "#89bf04",
                iconClass: "erp-variation-icon icon-ksc-icon-bling-solid",
                label: "global.erps.info.bling.integrated"
            },
            9: {
                color: "#da3063",
                iconClass: "erp-variation-icon icon-ksc-icon-nexaas-solid",
                label: "global.erps.info.nexaas.integrated"
            },
            8: {
                color: "#00806e",
                iconClass: "erp-variation-icon icon-ksc-icon-varejo-online-solid",
                label: "global.erps.info.varejoOnline.integrated"
            }
        };


        vm.$onInit = function() {
            vm.coverImages = [];
            if (Array.isArray(vm.flyer.flyerImages)) {
                vm.flyer.flyerImages.forEach(function (flyerImage) {
                    vm.coverImages.push({
                        id: flyerImage.id,
                        order: vm.coverImages.length,
                        path: getFlyerImageWithResolution(vm.flyer, 'original',
                            vm.flyer.flyerImages.indexOf(flyerImage))
                    });
                });
            }

            if (Array.isArray(vm.flyer.blueprintImages)) {
                vm.flyer.blueprintImages.forEach(function (blueprintImage) {
                    vm.coverImages.push({
                        id: blueprintImage.id,
                        order: vm.coverImages.length,
                        path: getFlyerBlueprintWithResolution(vm.flyer, 'original',
                            vm.flyer.blueprintImages.indexOf(blueprintImage))
                    });
                });
            }
            vm.coverImageIndex = vm.coverImages && vm.coverImages.length > 0 ? 0 : undefined;

            $scope.$watch('vm.coverImageIndex', function (selectedImageIndex) {
                if (selectedImageIndex !== undefined) {
                    vm.onSelectedChanged(vm.coverImages[selectedImageIndex].id);
                }
            });

            loadStore();

            if(!vm.isImmoContext && !vm.isHubContext) {
                loadErpConfiguration();
            }

            if (vm.flyer && vm.flyer.description) {
                vm.flyer.description = $sce.trustAsHtml(vm.flyer.description);
            }
        };

        vm.handleQuickActionClick = function (method, actionsArguments) {
            if (method !== undefined) {
                if (actionsArguments !== undefined && actionsArguments.constructor !== Array) {
                    actionsArguments = [actionsArguments];
                }
                method.apply(undefined, actionsArguments);
            }
        };

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(
                function (response) {
                    if (response && response.data) {
                        vm.currencyInstance = loadCurrencyPrefix(response.data);
                    }
                }
            );
        }

        function loadErpConfiguration() {
            ErpsSettingsService.getERPConfigurationByStoreId($localStorage.defaultStore.storeId)
                .then(function (response) {
                    if (response.data && response.data.id) {
                        vm.configuration = response.data;

                        if (vm.flyer && vm.flyer.erpProductId) {
                            vm.erpIcon = ERP_ICON_MAP[vm.configuration.partnerId] || null;
                        }
                    }
                });
        }

        function loadCurrencyPrefix(store) {
            var storeCurrency = store.currency ? store.currency : "REAL";
            return getCurrencyListConfiguration()[storeCurrency];
        }
    }
})();
